import React from 'react';
import cn from 'classnames';
import styles from './forms.module.css';

const FormButton = ({ children, className, onClick }) => (
  <button className={cn(styles.FormButton, className)} onClick={onClick}>
    {children}
  </button>
)

export default FormButton;
